import React from 'react';
import Heading from '../../../atoms/Heading/Heading';

type OurStorySectionProps = {
    storySection?: {
        title?: string;
        subTitle?: string;
        text?: string;
    };
};

const OurStorySection = ({ storySection }: OurStorySectionProps) => {
    return (
        <Heading
            title={storySection?.title}
            subTitle={storySection?.subTitle}
            text={storySection?.text}
            dotsPosition='afterSubtitle'
        />
    );
};

export default OurStorySection;
